import { combineReducers }    from 'redux';
import userCompetitionReducer from './userCompetitionReducer';

const rootReducer = combineReducers({
  configurator: userCompetitionReducer
});

export default rootReducer;
